import React, { useState, useEffect } from 'react';
import { Callout } from 'plaid-threads/Callout';

//  Allows user to input their personal assets such as a house or car.

const LoadingCallout: React.FC = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timerId = setTimeout(() => setShow(true), 8000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <>
      {show && (
        <Callout>
          We're having trouble getting your transactions. Try again later.
        </Callout>
      )}
    </>
  );
};

LoadingCallout.displayName = 'LoadingCallout';

export default LoadingCallout;
